(function () { 
	function defaultBadRequestHandler (error) {
		if (localStorage.getItem("__debug_mode") === "true")
		{
			throw error;
		}
		else
		{
			window.location = "error";
		}
	}
	
	window.handleServerErrors = function handleServerErrors(error, badRequestHandler) {
		if (error.status === 403)
		{
			window.location = "invalid-permissions";
		}
		else
		{
			(badRequestHandler || defaultBadRequestHandler)(error);
		}
	};
})();
